<div class="container">
    <div class="text-center">
        <h1>Storico</h1>
    </div>
    <div class="row mt-5 mb-3">
        <div class="col-12 text-end">
            <button class="btn btn-primary btn-sm m-1"
                (click)="aggiornaStorico()">aggiorna storico</button>
        </div>
    </div>
    <form [formGroup]="formFiltri">
        <div class="row">
            <div class="col-2">
                <mdb-form-control>
                    <mdb-select formControlName="selMarket">
                        <mdb-option *ngFor="let m of markets" (click)="selectMarket()" [value]="m.market">{{
                            m.market
                            }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Seleziona il mercato</label>
                </mdb-form-control>
            </div>
            <div class="col-2">
                <mdb-form-control>
                    <mdb-select formControlName="selDayweek">
                        <mdb-option [value]="0" (click)="selectMarket()">Tutti</mdb-option>
                        <mdb-option *ngFor="let d of days" (click)="selectMarket()" [value]="d.value">{{
                            d.label
                            }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Seleziona il giorno</label>
                </mdb-form-control>
            </div>
            <div class="col-2">
                <mdb-form-control>
                    <mdb-select formControlName="selOpen">
                        <mdb-option [value]="0" (click)="selectMarket()">Tutti</mdb-option>
                        <mdb-option *ngFor="let d of oraOpen" (click)="selectMarket()" [value]="d">{{
                            d
                            }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Seleziona Open</label>
                </mdb-form-control>
            </div>
        </div>
    </form>
    <div class="row" style="padding: 5px;">
        <div class="col-12">
            <div class="datatable mt-4">
                <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" 
                #sort="mdbTableSort" fixedHeader="true" [hover]="true" [responsive]="true"
                    [dataSource]="tableData" [pagination]="pagination" [sort]="sort" (sortChange)="onSortChange($event)">
                    <thead class="datatable-header">
                        <tr>
                            <th scope="col" *ngFor="let header of headers" [mdbTableSortHeader]="header" data-sort="true">
                                {{header}}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="datatable-body">
                        <tr *ngFor="let s of tableData">
                            <td>{{giornoSettimanaLabel(s.dayweek)}}</td>
                            <td>{{s.oraopen}}</td>
                            <td>{{s.oraclose}}</td>
                            <td>{{s.punti | number: '1.4-4'}}</td>
                            <td>{{s.numop}}</td>
                            <td>{{s.puntiop | number: '1.4-4'}}</td>
                            <td>{{s.percpos*100 | number: '1.2-2'}} %</td>
                            <td>{{s.rawal | number: '1.2-2'}}</td>
                            <td>{{s.kelly | number: '1.2-2'}}</td>
                            <td>
                                <div class="form-check">
                                    <input
                                      mdbCheckbox
                                      class="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="seleziona"
                                        [checked]="s.selezionato==1"
                                        (change)="selezionaTS(s.id, $event.target)"
                                    />
                                  </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <mdb-table-pagination #pagination></mdb-table-pagination>
            </div>
        </div>
    </div>
</div>